import React from 'react';
import { BookOpenIcon, UnlockIcon, LightbulbIcon, InfinityIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/translations';
export function WhatYouGetSection() {
  const {
    language
  } = useLanguage();
  const t = translations[language].whatYouGet;
  return <section className="py-20 px-4 bg-gradient-to-b from-black to-teal-950" data-id="element-468">
      <div className="max-w-5xl mx-auto" data-id="element-469">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-12 text-yellow-400" data-id="element-470">
          {t.title}
        </h2>
        <div className="bg-gradient-to-br from-yellow-950/30 to-black border-2 border-yellow-600/50 rounded-2xl p-8 md:p-12" data-id="element-471">
          <div className="flex items-center justify-between mb-8" data-id="element-472">
            <h3 className="text-3xl font-bold text-yellow-400" data-id="element-473">
              {t.coreSystem}
            </h3>
            <span className="text-xl text-teal-300 font-semibold" data-id="element-474">
              {t.value}
            </span>
          </div>
          <div className="space-y-6" data-id="element-475">
            {t.items.map((item, index) => <div key={index} className="flex items-start gap-4 p-4 bg-black/50 border border-yellow-600/30 rounded-xl" data-id="element-476">
                {index === 0 && <BookOpenIcon className="w-8 h-8 text-yellow-400 flex-shrink-0 mt-1" data-id="element-477" />}
                {index === 1 && <UnlockIcon className="w-8 h-8 text-yellow-400 flex-shrink-0 mt-1" data-id="element-478" />}
                {index === 2 && <LightbulbIcon className="w-8 h-8 text-yellow-400 flex-shrink-0 mt-1" data-id="element-479" />}
                {index === 3 && <InfinityIcon className="w-8 h-8 text-yellow-400 flex-shrink-0 mt-1" data-id="element-480" />}
                <div data-id="element-481">
                  <h4 className="text-xl font-bold text-white mb-2" data-id="element-482">
                    {item.title}
                  </h4>
                  <p className="text-gray-300" data-id="element-483">{item.description}</p>
                </div>
              </div>)}
          </div>
          <div className="mt-8 p-6 bg-yellow-950/50 border border-yellow-600/30 rounded-xl" data-id="element-484">
            <p className="text-lg text-center text-gray-200" data-id="element-485">
              {t.conclusion}{' '}
              <span className="text-yellow-400 font-bold" data-id="element-486">
                {t.conclusionHighlight}
              </span>{' '}
              {t.conclusionText}
            </p>
          </div>
        </div>
      </div>
    </section>;
}